<template>
  <PartnersLayout>
    <template #header>
      <PartnersHeader
        title="커뮤니티 광고 신청"
        subtitle="커뮤니티 게시글 형태로 노출되는 광고 (무료)"
      />
    </template>

    <div class="px-4 lg:px-6 pb-6">
      <div class="max-w-6xl mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- 왼쪽: 안내 및 바로가기 -->
          <div class="lg:col-span-1 space-y-4">
            <!-- 안내 카드 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <div class="flex items-center gap-2 mb-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 class="font-semibold text-slate-800">커뮤니티 광고 안내</h3>
              </div>
              <ul class="text-sm text-slate-600 space-y-2">
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 등록은 <strong class="text-blue-700">무료</strong>입니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>신청 후 <strong class="text-blue-700">관리자 승인</strong>이 필요합니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 기간은 <strong class="text-blue-700">1주일</strong>입니다</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>계정당 <strong class="text-blue-700">1개</strong>만 등록 가능</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>광고 유입 콜은 <strong class="text-blue-700">건당 10,000P</strong>에 구매</span>
                </li>
                <li class="flex items-start gap-2">
                  <span class="text-blue-500 mt-0.5">•</span>
                  <span>커뮤니티 피드에 <strong class="text-blue-700">게시글 형태</strong> 노출</span>
                </li>
              </ul>
            </div>

            <!-- 바로가기 -->
            <div class="bg-white rounded-2xl border border-slate-200 p-5">
              <h3 class="font-semibold text-slate-800 mb-3">바로가기</h3>
              <div class="space-y-2">
                <router-link
                  to="/partners/communityad/my"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">내 커뮤니티 광고</p>
                    <p class="text-xs text-slate-500">신청 현황 확인</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
                <router-link
                  to="/partners/ad/create"
                  class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition group"
                >
                  <div class="w-9 h-9 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
                    </svg>
                  </div>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-slate-700">캠페인 만들기</p>
                    <p class="text-xs text-slate-500">광고에 필요한 캠페인 생성</p>
                  </div>
                  <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </router-link>
              </div>
            </div>
          </div>

          <!-- 오른쪽: 메인 콘텐츠 -->
          <div class="lg:col-span-2">
            <!-- 로딩 -->
            <div v-if="loading" class="bg-white rounded-2xl border border-slate-200 p-12 text-center">
              <div class="spinner mx-auto mb-4"></div>
              <p class="text-slate-500">데이터를 불러오는 중...</p>
            </div>

            <!-- 이미 광고가 있는 경우 -->
            <div v-else-if="hasActiveAd" class="bg-amber-50 border border-amber-200 rounded-2xl p-6">
              <div class="flex items-start gap-3">
                <svg class="w-6 h-6 text-amber-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
                <div>
                  <p class="font-semibold text-amber-800">이미 등록된 광고가 있습니다</p>
                  <p class="text-sm text-amber-600 mt-1">계정당 1개의 광고만 등록할 수 있습니다.</p>
                  <p class="text-sm text-amber-600">기존 광고가 만료되거나 삭제된 후 새로운 광고를 신청해주세요.</p>
                  <router-link
                    to="/partners/communityad/my"
                    class="inline-flex items-center gap-1 mt-3 text-sm text-blue-600 font-medium hover:underline"
                  >
                    내 광고 확인하기
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- 캠페인 없음 안내 -->
            <div v-else-if="campaigns.length === 0" class="bg-amber-50 border border-amber-200 rounded-2xl p-6">
              <div class="flex items-center gap-3">
                <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
                <div>
                  <p class="font-semibold text-amber-800">활성화된 캠페인이 없습니다</p>
                  <p class="text-sm text-amber-600">커뮤니티 광고를 등록하려면 먼저 캠페인을 생성해주세요.</p>
                  <router-link to="/partners/ad/create" class="inline-flex items-center gap-1 mt-2 text-sm text-blue-600 font-medium hover:underline">
                    캠페인 만들기
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>

            <div v-else class="space-y-4">
              <!-- 캠페인 선택 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">1. 캠페인 선택</h2>

                <div class="space-y-3">
                  <label
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    :class="[
                      'flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition',
                      selectedCampaign?.id === campaign.id
                        ? 'border-blue-500 bg-blue-50'
                        : 'border-slate-200 hover:border-blue-300'
                    ]"
                  >
                    <input
                      type="radio"
                      :value="campaign"
                      v-model="selectedCampaign"
                      class="w-5 h-5 text-blue-600"
                    />
                    <div class="flex-1">
                      <h3 class="font-semibold text-slate-800">{{ campaign.propertyName }}</h3>
                      <p class="text-sm text-slate-500">캠페인 코드: {{ campaign.code }}</p>
                      <p class="text-xs text-slate-400 mt-1">만료일: {{ campaign.endDate }}</p>
                    </div>
                    <span class="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                      활성
                    </span>
                  </label>
                </div>
              </div>

              <!-- 시간대 선택 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-2">2. 노출 시간대 선택</h2>
                <p class="text-sm text-slate-500 mb-4">광고가 노출될 시간대를 선택하세요. (1개만 선택 가능)</p>

                <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
                  <button
                    v-for="slot in timeSlots"
                    :key="slot.id"
                    type="button"
                    @click="selectedTimeSlot = slot"
                    :class="[
                      'p-3 rounded-xl border-2 text-left transition',
                      selectedTimeSlot?.id === slot.id
                        ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-500/20'
                        : 'border-slate-200 hover:border-blue-300 hover:bg-blue-50/50'
                    ]"
                  >
                    <p :class="['text-sm font-medium', selectedTimeSlot?.id === slot.id ? 'text-blue-700' : 'text-slate-700']">{{ slot.label }}</p>
                    <p :class="['text-xs mt-0.5', selectedTimeSlot?.id === slot.id ? 'text-blue-500' : 'text-slate-400']">{{ slot.start }}-{{ slot.end }}</p>
                  </button>
                </div>
              </div>

              <!-- 게시글 형태 작성 -->
              <div class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">3. 광고 게시글 작성</h2>

                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-slate-600 mb-2">제목 (필수)</label>
                    <input
                      v-model="adTitle"
                      type="text"
                      maxlength="50"
                      placeholder="예: 래미안 원베일리 특별분양 안내"
                      class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                    />
                    <p class="text-xs text-slate-400 mt-1">{{ adTitle.length }}/50자</p>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-slate-600 mb-2">한줄 소개 (필수)</label>
                    <input
                      v-model="adContent"
                      type="text"
                      maxlength="100"
                      placeholder="예: 강남 핵심 입지, 프리미엄 주거단지 특별분양!"
                      class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none"
                    />
                    <p class="text-xs text-slate-400 mt-1">{{ adContent.length }}/100자</p>
                  </div>
                </div>
              </div>

              <!-- 미리보기 -->
              <div v-if="adTitle && adContent" class="bg-white rounded-2xl border border-slate-200 p-6">
                <h2 class="text-lg font-semibold text-slate-800 mb-4">4. 미리보기</h2>

                <!-- 게시글 미리보기 카드 -->
                <div class="border border-slate-200 rounded-xl overflow-hidden">
                  <!-- 내용 -->
                  <div class="p-4">
                    <div class="flex items-center gap-2 mb-2">
                      <span class="px-2 py-0.5 text-xs font-semibold bg-amber-100 text-amber-700 rounded">AD</span>
                      <span class="text-xs text-slate-400">{{ selectedCampaign?.propertyName || '현장명' }}</span>
                    </div>
                    <h3 class="font-semibold text-slate-800 mb-1">{{ adTitle }}</h3>
                    <p class="text-sm text-slate-600">{{ adContent }}</p>
                    <div class="flex items-center justify-between mt-3 pt-3 border-t border-slate-100">
                      <span class="text-xs text-amber-600 font-medium">{{ userProfile?.name || '상담사명' }}</span>
                      <span class="text-xs text-amber-500 font-semibold flex items-center gap-1">
                        자세히 보기
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- 노출 정보 -->
                <div v-if="selectedTimeSlot" class="mt-4 p-4 bg-blue-50 rounded-xl">
                  <div class="flex items-center gap-2 text-blue-700">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span class="font-medium">노출 시간: {{ selectedTimeSlot.label }} ({{ selectedTimeSlot.start }} - {{ selectedTimeSlot.end }})</span>
                  </div>
                  <p class="text-sm text-blue-600 mt-1">승인 후 1주일간 커뮤니티 목록에 노출됩니다.</p>
                </div>
              </div>

              <!-- 신청 버튼 -->
              <button
                v-if="canSubmit"
                @click="handleSubmit"
                :disabled="submitting"
                class="w-full py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {{ submitting ? '신청 중...' : '광고 신청하기 (무료)' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PartnersLayout>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import PartnersLayout from '@/components/partners/common/PartnersLayout.vue'
import PartnersHeader from '@/components/partners/common/PartnersHeader.vue'
import { useAuth } from '@/composables/common/useAuth'
import { useCommunityAd } from '@/composables/partners/useCommunityAd'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db } from '@/firebase/firebase'

export default {
  name: 'CommunityAdPurchaseView',
  components: {
    PartnersLayout,
    PartnersHeader
  },
  setup() {
    const router = useRouter()
    const { user, userProfile } = useAuth()
    const { TIME_SLOTS, createCommunityAd, checkExistingCommunityAd } = useCommunityAd()

    const loading = ref(true)
    const campaigns = ref([])
    const selectedCampaign = ref(null)
    const selectedTimeSlot = ref(null)
    const adTitle = ref('')
    const adContent = ref('')
    const submitting = ref(false)
    const hasActiveAd = ref(false)

    const timeSlots = TIME_SLOTS

    const canSubmit = computed(() => {
      return selectedCampaign.value &&
             selectedTimeSlot.value &&
             adTitle.value.trim() &&
             adContent.value.trim()
    })

    // 활성 캠페인 로드
    const loadCampaigns = async () => {
      if (!user.value) return

      try {
        const q = query(
          collection(db, 'campaigns'),
          where('partnerId', '==', user.value.uid),
          where('status', '==', 'active')
        )
        const snapshot = await getDocs(q)

        campaigns.value = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        // 캠페인이 하나면 자동 선택
        if (campaigns.value.length === 1) {
          selectedCampaign.value = campaigns.value[0]
        }
      } catch (err) {
        console.error('캠페인 로드 실패:', err)
      }
    }

    const handleSubmit = async () => {
      if (!canSubmit.value || submitting.value) return

      // 다시 한번 확인
      const exists = await checkExistingCommunityAd(user.value.uid)
      if (exists) {
        alert('이미 등록된 광고가 있습니다.\n기존 광고가 만료되거나 삭제된 후 새로운 광고를 신청해주세요.')
        hasActiveAd.value = true
        return
      }

      if (!confirm('광고를 신청하시겠습니까?\n관리자 승인 후 1주일간 커뮤니티에 노출됩니다.')) {
        return
      }

      submitting.value = true

      try {
        // 광고 신청 생성
        await createCommunityAd({
          partnerId: user.value.uid,
          partnerEmail: user.value.email,
          partnerDisplayName: userProfile.value?.name || user.value.email,
          propertyId: selectedCampaign.value.propertyId,
          propertyName: selectedCampaign.value.propertyName,
          campaignId: selectedCampaign.value.id,
          campaignCode: selectedCampaign.value.code,
          title: adTitle.value.trim(),
          content: adContent.value.trim(),
          linkUrl: `/p/${selectedCampaign.value.code}`,
          timeSlot: {
            id: selectedTimeSlot.value.id,
            label: selectedTimeSlot.value.label,
            start: selectedTimeSlot.value.start,
            end: selectedTimeSlot.value.end
          }
        })

        alert('광고 신청이 완료되었습니다!\n관리자 승인 후 1주일간 커뮤니티에 노출됩니다.')

        // 내 광고 페이지로 이동
        router.push('/partners/communityad/my')
      } catch (err) {
        console.error('광고 신청 실패:', err)
        alert('신청 실패: ' + err.message)
      } finally {
        submitting.value = false
      }
    }

    onMounted(async () => {
      loading.value = true

      // 기존 광고 확인
      if (user.value) {
        hasActiveAd.value = await checkExistingCommunityAd(user.value.uid)
      }

      // 캠페인 로드
      if (!hasActiveAd.value) {
        await loadCampaigns()
      }

      loading.value = false
    })

    return {
      loading,
      campaigns,
      selectedCampaign,
      selectedTimeSlot,
      timeSlots,
      adTitle,
      adContent,
      canSubmit,
      submitting,
      hasActiveAd,
      userProfile,
      handleSubmit
    }
  }
}
</script>

<style scoped>
@reference "tailwindcss";

.spinner {
  @apply w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
